import moment from 'moment'

export const checkMonth = (monthNext, monthOld, yearOld, yearNext) => {
    let arrow = 'arrowFormFalse';
    console.log(yearNext)
    if(monthNext+''+yearNext === moment().month()+''+moment().year()){
        arrow = 'arrowForm2';
    }

    if(moment().year()-1 == yearNext && moment().month() == monthNext){
        arrow = 'arrowForm1';
    }else if(moment().year()-1 == yearNext && moment().month() < monthNext){
        arrow = 'arrowFormFalse';
    }

    if(monthNext == 11 && monthOld == 0){
        return [arrow,moment().year()-1,moment().year()]
    }else if(monthNext == 0 && monthOld == 11){
        return [arrow,moment().year(),moment().year()]
    } else{
        return [arrow,yearOld,yearNext]
    }
}